import URI from 'jsuri';
import isArray from 'lodash/isArray';
import Q from 'q';

import productPriceApi from 'bundles/payments/api/productPrices';

/**
 * Call the product API and return a promise with the the raw response data.
 *
 * @param {String|Array} productIds On a string, do a single call, on an array, do a multi-get.
 */
export default (productIds: string | string[]) => {
  const productPricesUri = new URI()
    .addQueryParam('q', 'byProductIds')
    .addQueryParam('productIds', isArray(productIds) ? productIds.join() : productIds);
  return Q(productPriceApi.get(productPricesUri.toString()));
};
